import {FeedbackTypeModel} from "./feedback-type.model"

export class FeedbackModel {

  constructor(public id?: string,
    public email?: string,
    public feedbackStatusId?: string,
    public feedbackContent?: string,
    public isParticipatingInResearch?: boolean,
    public isReplyExpected?: boolean,
    public isPageRelated?: boolean,
    public pageName?: string,
    public isServiceRelated?: boolean,
    public serviceName?: string,
    public feedbackAboutOptions?: FeedbackTypeModel[]
  ) {}
}
